// extracted by mini-css-extract-plugin
export default {"buttons":"LogoPage_buttons__qj902","none":"LogoPage_none__szSAb","opacity-effect":"LogoPage_opacity-effect__qoaxK"};